import React, { useContext, useState, useEffect } from 'react'
import Layout from '../../common/layout/layout'
import { Row, Col, Button } from 'react-bootstrap'
import OrderItem from './orderItem'
import styles from './index.module.css'
import { AuthContext } from '../../../contexts/authContext'
import {
  viewAllPlacedOrders,
  ViewOrderItem
} from '../../../services/orderService'
import Tabs from '../../common/sections/tabs'
import OngoingInstallment from './ongoingInstallment'
import { Order } from '../../../models/Order'
import { OrderStatus } from '../../../config/enums'

const Orders: React.FC = () => {
  const authContext = useContext(AuthContext)!
  const [orders, setOrders] = useState<ViewOrderItem[]>([])
  const [limit, setLimit] = useState(10)
  const [tabNames, setTabNames] = useState(['Order History'])
  const [activeTab, setActiveTab] = useState('Order History')
  const [installmentOrders, setInstallmentOrders] = useState<Order[]>([])

  useEffect(() => {
    if (authContext.user?.uid) {
      viewAllPlacedOrders(authContext.user?.uid, limit).then(orders => {
        setOrders(orders)

        const filteredOrders: Order[] = []
        orders.forEach(order => {
          if (
            order.isInstallment &&
            !order.isInstallmentDone &&
            order.rawOrder.status !== OrderStatus.rejected
          ) {
            filteredOrders.push(order.rawOrder)
          }
        })
        setInstallmentOrders(filteredOrders)

        if (filteredOrders.length > 0) {
          setActiveTab('Ongoing Installment')
          setTabNames(['Ongoing Installment', 'Order History'])
        } else {
          setActiveTab('Order History')
          setTabNames(['Order History'])
        }
      })
    }
  }, [authContext.user, limit])

  return (
    <Layout>
      <Row>
        <Col xl={8} className="mx-auto">
          <Row>
            <Col className="pb-3">
              <h1 className="pageTitle">Your Orders</h1>
            </Col>
          </Row>

          {tabNames.length > 1 && (
            <Tabs
              tabNames={tabNames}
              onChangeTab={tab => setActiveTab(tab)}
              activeTab={activeTab}
            />
          )}

          {activeTab === tabNames[0] &&
            tabNames.length === 2 &&
            installmentOrders.length > 0 &&
            installmentOrders.map(order => {
              return <OngoingInstallment key={order.id} order={order} />
            })}

          {(activeTab === tabNames[1] || tabNames.length === 1) && (
            <>
              <Row
                className={`mx-auto ${styles.bottomRowBorder}`}
                data-testid="ordersContainer"
                noGutters={true}
              >
                {orders.map((order, index) => {
                  return (
                    <OrderItem
                      key={index}
                      orderNumber={order.orderNumber}
                      orderId={order.orderId}
                      date={order.date}
                      price={order.price}
                    />
                  )
                })}
              </Row>

              {orders.length <= 0 ? (
                <Row className="pt-5">
                  <Col className="text-center">No orders.</Col>
                </Row>
              ) : null}

              {orders.length < limit ? null : (
                <Row className="pt-5">
                  <Col className="text-center">
                    <Button
                      variant="secondary"
                      data-testid="load-more"
                      onClick={() => {
                        setLimit(limit + 5)
                      }}
                    >
                      Load More
                    </Button>
                  </Col>
                </Row>
              )}
            </>
          )}
        </Col>
      </Row>
    </Layout>
  )
}

export default Orders
